export default __webpack_public_path__ + "/dist/images/recipe.aa71d358aca3940c9a0207f15e04e0d1.svg";